/** «Поделиться в чат»: пишет ссылку на задачу/заявку в выбранный канал. Превью соберёт сам чат. */

import { useEffect, useState } from 'react';
import { apiErrorText, chatsApi, type ChatView } from '@/shared/api';
import { Button, Dialog, DialogContent, DialogFooter, DialogTitle, Field, Select, Textarea, toast } from '@/shared/ui';
import styles from './ShareToChatDialog.module.css';

interface Props {
  open: boolean;
  /** Что отправляем: ключ/номер и заголовок — текст сообщения по умолчанию. */
  refText: string;
  title: string;
  onClose: () => void;
}

export function ShareToChatDialog({ open, refText, title, onClose }: Props) {
  const [chats, setChats] = useState<ChatView[]>([]);
  const [chatId, setChatId] = useState('');
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (!open) return;
    setText(`${refText} — ${title}`);
    void chatsApi.list().then((list) => {
      setChats(list);
      setChatId((prev) => prev || list[0]?.id || '');
    }).catch(() => setChats([]));
  }, [open, refText, title]);

  const send = async () => {
    if (!chatId) return;
    setSending(true);
    try {
      await chatsApi.send(chatId, { body: text.trim() || refText });
      toast.success('Отправлено в канал');
      onClose();
    } catch (err) {
      toast.error(apiErrorText(err, 'Не удалось отправить'));
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent>
        <DialogTitle>Поделиться в чат</DialogTitle>
        <div className={styles.body}>
          <Field label="Канал" floated>
            <Select value={chatId} onValueChange={setChatId} options={chats.map((c) => ({ value: c.id, label: c.title }))} />
          </Field>
          <Field label="Сообщение" floated hint="Ключ или номер развернётся в карточку">
            <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} />
          </Field>
          {chats.length === 0 && <p className={styles.hint}>Каналов нет — вы не состоите ни в одной группе.</p>}
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>Отмена</Button>
          <Button onClick={() => void send()} disabled={sending || !chatId}>Отправить</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
